<template>
    <div>
      <div v-if="bIsLoading">Загружаем данные...</div>
      <card v-else>
        <template v-if="!bEdit">
            <button v-if="!bIsAdd" class="btn btn-simple btn-primary" @click="Add()">Добавить</button>
            <button v-if="!bIsAdd" class="btn btn-simple btn-primary" @click="Return()">Назад</button>
        </template>
        <card v-show="!bEdit">
            <h4> Продвижения площадки {{ site.name }}</h4>
                <el-table :data="ApiSitesTable" style="width: 100%;">
                    <el-table-column
                        label="ID"
                        property="siteTermId"
                        width="80"
                    >
                    </el-table-column>
                    <el-table-column 
                        min-width="180"
                        label="Тип"
                        property="name"
                    >
                    </el-table-column>
                    <el-table-column 
                        min-width="180"
                        label="На зипал"
                        property="type"
                    >
                    </el-table-column>
                    <el-table-column 
                        min-width="180"
                        label="На площадку"
                        property="type_local"
                    >
                    </el-table-column>
                    <el-table-column 
                        min-width="180"
                        label="Цена зипала"
                        property="price"
                    >
                    </el-table-column>
                    <el-table-column
                            width="280"
                            label="Действие"
                            align="right"                    	
                    >
                        <template v-slot="scope">
                            <!-- 
                            <el-tooltip content="Управление доступами к пакетам" placement="top">
                                <el-button class="no-border my-0">
                                    <button class="btn btn-icon btn-simple btn-info" @click="GoAccessEdit(scope.row)">
                                        <i class="tim-icons icon-settings-gear-63"></i>
                                    </button>											
                                </el-button>
                            </el-tooltip>
                            -->
                            <template v-if="canEdit">
                                
                                <el-tooltip content="Редактировать продвижение" placement="top">
                                    <el-button class="no-border my-0 mr-3">
                                        <button class="ml-1 btn btn-icon btn-simple btn-primary" @click="GoEdit(scope.row)">
                                            <i class="tim-icons icon-pencil"></i>
                                        </button>
                                    </el-button>
                                </el-tooltip>		
                                <!--
                                <el-tooltip content="Редактировать продвижения" placement="top">
                                    <el-button class="no-border my-0 mr-3">
                                        <button class="ml-1 btn btn-icon btn-simple btn-primary" @click="GoTerms(scope.row)">
                                            <i class="tim-icons icon-user-run"></i>
                                        </button>
                                    </el-button>
                                </el-tooltip>		
                                -->
    
                                <!-- <div class="d-flex justify-content-end"></div> -->
                            </template>	
                                    
                        </template>
                    </el-table-column>
                
                </el-table>
        </card>
        <card v-show="bEdit">
            Редактируем {{ termId }} <button class="btn btn-simple btn-primary" @click="CloseForm()">Закрыть</button>
            <h4>Задайте настройки подвижения для {{ site.name }}</h4>
            <ReFormPrinter :masFormConfig="masAllFormParams" :objSaveApiMethod="currentApiFormMethod" :SuccessGo="SuccessGo" SuccessBtnText="Сохранить" />
        </card>
      </card>
    </div>
  </template>
  
  <script>
    import { Table, TableColumn, Select, Option, Tooltip, Button } from 'element-ui';
    import ReFormPrinter from '../our_components/FormPrinter/ReFormPrinter.vue';
  
  export default {
    name: 'SitesTermsEditor',
    components: {
          [Table.name]: Table,
          [TableColumn.name]: TableColumn,
          [Tooltip.name]: Tooltip,
          [Button.name]: Button,
          ReFormPrinter,
      },
    data() {
      return {
        ApiSitesTable: [],
        bIsAdd: false,
        bIsLoading: true,
        bEdit: false,
        termId: 0,
        masAllFormParams: [],
        currentApiFormMethod: undefined,
        site:{},
      };
    },
    computed:{
      canEdit(){
          return this.$GVO.my_profile.adm
      },
      siteId(){
            return this.$route.params.id||0;
      },
      baseUrl(){
        return '/data/sites/'+this.siteId+'/terms';
      }
    },
    watch:{
        siteId(oldId, newId){
            // console.log(this.siteId);
        }
    },
    methods: {
      getApiSites(){
          this.bIsLoading=true;
          this.$GVO.Api.marketing_sites.GET({flt:{id:this.siteId}}).then(objApi=>{
            if(objApi && objApi.data && objApi.data[0]){
                this.site = objApi.data[0]
            }
          })
            this.loadTable();  
      },
      loadTable(){
        this.$GVO.Api.marketing_sites_terms.GET({flt:{siteId: this.siteId}})
          .then((objApi) => {
              // this.ApiSitesTable = [];
              if(objApi.success === true){
                  if(objApi.data.length > 0){
                      this.ApiSitesTable = objApi.data;
                      // if(objApi.total!=undefined) { this.masObjectsNew_total=objApi.total; }
                  }else{
                      this.ApiSitesTable=[];
                  }
              }
              this.bIsLoading = false;
          }).catch(errorObjApi => {console.error(errorObjApi); this.ApiSitesTable = [];});
      },
      Add(){
          // this.$router.push({path: this.baseUrl+'/add'});
          this.termId = 0;
          this.bEdit = true;
          this.loadForm()
      },
      GoEdit(row){
          // this.$router.push({path: this.baseUrl+'/'+row.siteTermId});
          this.termId=row.siteTermId;
          this.bEdit = true;
          this.loadForm()
      },
      CloseForm(){
        this.masAllFormParams = [];
        this.bEdit = false;
      },
      SuccessGo(params){
        // console.log(params);
        this.CloseForm();
        this.loadTable();
      },
      Return(){
        this.$router.push({path: '/data/sites/'});
      },
      loadForm(){
        this.masAllFormParams = [];
        this.currentApiFormMethod = this.currentApiFormMethodComp();
        this.$GVO.Api.marketing_sites_terms.GET_FORM_MODEL({flt:{result_id: this.termId, site_id: this.siteId}})
            .then((objApi) => {
                if(objApi.success && this.bEdit){
                    this.masAllFormParams = objApi.config;
                }
            })
            .catch(errorObjApi => console.error(errorObjApi));
        return [];
      },
        currentApiFormMethodComp(){
            return {apiMethod:'marketing_sites_terms.INSUPD',apiParam:{iData:[],flt:{id: this.termId, site_id: this.siteId}}};
        },      
    },
    mounted() {
      this.getApiSites();

    }
  };
  </script>
  
  <style scoped>
  
  </style>